import { null as zNull } from "zod";

export const disconnectRivoIntegration = {
  name: "disconnectRivoIntegration" as const,
  input: zNull(),
  output: zNull(),
};
